import styled from '@bd/bdui-styles/emotion';
import FilterBar from '@bd/bdui-filterbar';

import { colors } from '../styles';

export default styled(FilterBar)`
  position: relative;
  z-index: 3;
  @media(min-width: 992px) {
    z-index: 1;
    display: inline-block;
    vertical-align: top;
    width: 100%;
  }
  .FilterBar_wrapper {
    position: relative;
    z-index: 1;
  }
  .FilterBar_list {
    list-style: none;
    padding: 0;
    margin: 0;
    vertical-align: top;
    display: flex;
    flex-direction: column;
    width: 100%;
    @media(min-width: 992px) {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .FilterBar_listItem {
      display: inline-block;
      font-weight: 700;
      font-size: 15px;
      vertical-align: top;
      background-image: url('/images/icon-triangle-down.svg');
      background-position: calc(100% - 12px) center;
      background-repeat: no-repeat;
      background-color: #FFFFFF;
      margin: 0 0 15px;
      color: #1F1F1F;
      letter-spacing: 0;
      line-height: 24px;
      @media(min-width: 768px) {
        font-size: 17px;
      }
      @media(min-width: 992px) {
        &:nth-child(1), &:nth-child(2) {
          width: 49%;
        }
      }
    }
  }
  .FilterSelect_inner {
    @media(min-width: 992px) {
      position: relative;
    }
  }
  .FilterSelect_title {
    padding: 0 45px 0 30px;
    cursor: pointer;
    line-height: 50px;
    display: block;
    position: relative;
    &::after {
      content: '';
      border-top: 7px solid #B7B7B7;
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 18px;
    }
    &:focus {
      outline: none;
    }
  }
  .FilterSelect_dropdown {
    position: relative;
    list-style: none;
    padding: 0 10px 20px;
    background: #FFFFFF;
    min-width: 200px;
    width: 100%;
    @media(min-width: 992px) {
      position: absolute;
      box-shadow: 0 10px 15px 0 rgba(0,0,0,0.50);
      width: 100%;
      box-shadow: none;
      padding: 0 15px 20px;
      z-index: 1;
    }
  }
  .FilterSelect_dropdownItem {
    font-weight: 400;
    font-size: 14px;
    color: #212121;
    border-bottom: 1px solid #CFCFCF;
    width: 100%;
    position: relative;
    padding-left: 25px;
    @media(min-width: 992px) {
      font-size: 16px;
      color: #212121;
      line-height: 26px;
    }
    &:last-child {
      border: 0;
    }
  }
  .FilterSelect_dropdownItemButton {
    padding: 7px 0 7px 7px;
    display: inline-block;
    cursor: pointer;
    width: calc(100% - 30px);
    @media(min-width: 768px) {
      padding: 10px 0;
    }
  }
  .FilterSelect_dropdownItemCheckbox {
    text-rendering: optimizeSpeed;
    width: 15px;
    height: 15px;
    margin: 15px 0 0;
    margin-right: 1px;
    display: block;
    float: left;
    position: relative;
    cursor: pointer;
    @media(min-width: 992px) {
      top: 0;
      right: 4px;
    }
    &::after {
      content: "";
      vertical-align: middle;
      text-align: center;
      line-height: 13px;
      position: absolute;
      cursor: pointer;
      height: 15px;
      width: 15px;
      left: 0;
      top: 0;
      font-size: 10px;
      box-shadow: inset 0 1px 1px #FFFFFF, 0 1px 0 #FFFFFF;
      transition: all .1s ease-out;
      background: #d9d9d9;
      @media(min-width: 992px) {
      }
    }
    &:hover::after, &:checked:hover::after {
      background: #FFFFFF;
      content: '\\2714';
      color: ${colors.color1};
      font-size: 16px;
    }
    &:checked::after {
      background: #FFFFFF;
      content: '\\2714';
      color: #000000;
      font-size: 16px;
    }
  }

  .FilterSelect_wrapper-active .FilterSelect_title {
    &::after {
      border-top: 0;
      border-bottom: 7px solid #B7B7B7;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/FilterBar.js